// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","701":"homeM"}[chunkId] + "-legacy." + {"177":"810ad7d9","701":"07d798a0"}[chunkId] + ".js";
};